// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat {
  position: relative;
  font-size: 14px;
  line-height: 100%;
  text-align: left;
  padding: 20px;
  background: var(--accent-color);
  color: #fff;
  border-radius: 12px;
}
@media (max-width: 767px) {
  .chat {
    padding: 14px;
  }
}
.chat--dragging {
  border-color: #fff;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);
}
.chat__drop-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(var(--accent-color), 0.92);
  border: 2px dashed #fff;
  border-radius: 12px;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.chat__drop-overlay-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
}
.chat__drop-overlay-content svg {
  width: 40px;
  height: 40px;
}
.chat__drop-overlay-content svg path {
  fill: #fff;
}
.chat__message-item {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  align-items: start;
}
.chat__message-time {
  position: relative;
  width: 100%;
  font-size: 11px;
  color: #8b8b8b;
  text-align: left;
  margin-top: 4px;
}
.chat__message-time--from {
  text-align: right;
}
.chat__message-log {
  display: flex;
  flex-direction: column;
  padding: 12px;
  background: transparent;
  border: 1px solid var(--primary-color);
  border-radius: 12px;
  width: 100%;
  margin-bottom: 12px;
  gap: 10px;
}
.chat__message-log-title {
  font-weight: 500;
  font-size: 12px;
  line-height: 120%;
  color: #fff;
  opacity: 0.6;
}
.chat__message-log-item {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  width: 100%;
}
@media (max-width: 480px) {
  .chat__message-log-item {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}
.chat__message-log-name {
  font-weight: 500;
  font-size: 12px;
  line-height: 120%;
  color: #fff;
  margin-right: auto;
}
.chat__message-log-arrow {
  color: #fff;
  opacity: 0.5;
  font-size: 12px;
  font-weight: 500;
}
.chat__info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.chat__status {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px;
  background: var(--primary-color);
  color: #fff;
  border-radius: 12px;
  line-height: 100%;
}
.chat__status span {
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #fff;
}
.chat__paid {
  position: relative;
  padding: 9px 16px;
  background: #d6e4ff;
  border-radius: 12px;
  box-shadow: 4px 8px 24px rgba(116, 131, 244, 0.1);
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
  text-transform: uppercase;
  color: #4b79ff;
}
.chat__content {
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 0px 10px 0px 0px;
  margin: 20px 0;
  height: 580px;
  overflow-x: auto;
}
@media (max-width: 992px) {
  .chat__content {
    height: 480px;
  }
}
@media (max-width: 767px) {
  .chat__content {
    height: 380px;
  }
}
.chat__content::-webkit-scrollbar {
  width: 6px;
}
.chat__content::-webkit-scrollbar-track {
  background: #fff;
}
.chat__content::-webkit-scrollbar-thumb {
  background: var(--primary-color);
}
.chat__content::-webkit-scrollbar-thumb:hover {
  background: var(--primary-color);
}
.chat__message-status {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 12px;
  background: transparent;
  border: 1px solid var(--primary-color);
  border-radius: 12px;
  margin-bottom: 12px;
  gap: 8px;
}
.chat__message-status span {
  font-weight: 500;
  font-size: 12px;
  line-height: 120%;
  color: #fff;
}
.chat__message-status-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
}
@media (max-width: 480px) {
  .chat__message-status-main {
    flex-wrap: wrap;
  }
}
.chat__message-images-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}
.chat__message-images-wrap--from {
  align-items: flex-end;
}
.chat__message-images {
  position: relative;
  display: flex;
  gap: 10px;
  z-index: 1;
  margin-bottom: 8px;
}
.chat__message-images--from {
  align-self: flex-end;
}
.chat__message-images-img {
  position: relative;
  left: 0;
  top: 0;
  width: 80px;
  height: 80px;
  z-index: 1;
  border-radius: 12px;
  overflow: hidden;
}
.chat__message-images-img img {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s ease;
}
.chat__message-images-img:hover img {
  transform: scale(1.05);
}
.chat__message {
  display: inline-flex;
  align-items: flex-end;
  gap: 8px;
  max-width: 85%;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  text-align: left;
  padding: 12px;
  color: #fff;
  background: var(--primary-color);
  border-radius: 2px 16px 16px 16px;
  margin-bottom: 12px;
  word-break: break-word;
}
.chat__message--from {
  background: #374151;
  border-radius: 16px 16px 2px 16px;
  color: #fff;
  align-self: flex-end;
}
.chat__message-text {
  white-space: pre-wrap;
  word-break: break-word;
}
.chat__message-meta {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 2px;
}
.chat__message-meta--outside {
  padding-right: 2px;
  margin-top: -4px;
  margin-bottom: 8px;
}
.chat__message-time-inline {
  flex-shrink: 0;
  align-self: flex-end;
  font-size: 11px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.65);
  margin-left: 4px;
  white-space: nowrap;
}
.chat__form {
  position: relative;
}
.chat__form-images {
  position: relative;
  display: flex;
  gap: 10px;
  z-index: 1;
  margin-bottom: 20px;
}
.chat__form-wrapper {
  position: relative;
}
.chat__form-controls {
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 2;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}
.chat__form-controls a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: #ffd0d0;
  border-radius: 9px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.chat__form-controls a:hover {
  background: #FF2B2B;
}
.chat__form-controls a:hover svg {
  width: 8px;
  height: 8px;
}
.chat__form-controls a:hover svg path {
  stroke: #ffd0d0;
}
.chat__form-controls a svg {
  width: 8px;
  height: 8px;
}
.chat__form-controls a svg path {
  stroke: #FF2B2B;
  transition: all 0.3s ease;
}
.chat__form-img {
  position: relative;
  left: 0;
  top: 0;
  width: 80px;
  height: 80px;
  z-index: 1;
  border-radius: 12px;
  overflow: hidden;
}
.chat__form-img a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}
.chat__form-img img {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s ease;
}
.chat__form-img:hover img {
  transform: scale(1.05);
}
.chat__form-img:hover .chat__form-controls {
  opacity: 1;
  visibility: visible;
}
.chat__form-attach {
  position: absolute;
  left: 15px;
  top: 13px;
  z-index: 1;
  cursor: pointer;
}
.chat__form-attach svg {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.chat__form-attach svg path {
  fill: #fff;
  transition: all 0.3s ease;
}
.chat__form-attach:hover svg path {
  fill: var(--accent-color);
}
.chat__form-attach input {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  cursor: pointer;
}
.chat__form-textarea {
  position: relative;
}
.chat__form-textarea input {
  position: relative;
  display: block;
  width: 100%;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.6;
  letter-spacing: 0.2px;
  text-align: left;
  color: #fff;
  padding: 10px 43px;
  background: var(--primary-color);
  border-radius: 12px;
  border: none;
  outline: none;
}
.chat__form-textarea input::placeholder {
  color: #9e9e9e;
  font-weight: 500;
  font-family: "IBM Plex Sans", sans-serif;
}
.chat__form-button {
  position: absolute;
  right: 5px;
  top: 5px;
}
.chat__form-btn {
  position: relative;
  width: 33px;
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 10px;
  background: var(--accent-color);
  transition: all 0.3s ease;
  cursor: pointer;
}
.chat__form-btn:hover {
  background: var(--additional-color);
}
.chat__form-btn:hover svg path {
  fill: var(--accent-color);
}
.chat__form-btn:active {
  transform: scale(0.95);
}
.chat__form-btn svg {
  position: relative;
  right: -1px;
  width: 15px;
  height: 15px;
}
.chat__form-btn svg path {
  fill: #FFFFFF;
  transition: all 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/Chat/Chat.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EAEE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,+BCRQ;EDSR,WAAA;EACA,mBAAA;AAFF;AAIE;EAXF;IAYI,aAAA;EADF;AACF;AAGE;EACE,kBAAA;EACA,8CAAA;AADJ;AAIE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAFJ;AAII;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAFN;AAIM;EACE,WAAA;EACA,YAAA;AAFR;AAIQ;EACE,UAAA;AAFV;AAQE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AANJ;AASE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAPJ;AASI;EACE,iBAAA;AAPN;AAWE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,sCAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;AATJ;AAWI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AATN;AAYI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,WAAA;AAVN;AAYM;EAPF;IAQI,eAAA;IACA,2BAAA;EATN;AACF;AAYI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAVN;AAaI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAXN;AAeE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,gCC5IG;ED6IH,WAAA;EACA,mBAAA;EACA,iBAAA;AAdJ;AAgBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AAdN;AAkBE;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AAjBJ;AAmBI;EATF;IAUI,aAAA;EAhBJ;AACF;AAkBI;EAbF;IAcI,aAAA;EAfJ;AACF;AAiBI;EACE,UAAA;AAfN;AAkBI;EACE,gBAAA;AAhBN;AAmBI;EACE,gCCnMC;ADkLP;AAoBI;EACE,gCCvMC;ADqLP;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,sCAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AApBJ;AAsBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AApBN;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;AAtBJ;AAwBI;EAPF;IAQI,eAAA;EArBJ;AACF;AAwBE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AAtBJ;AAwBI;EACE,qBAAA;AAtBN;AA0BE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAxBJ;AA0BI;EACE,oBAAA;AAxBN;AA2BI;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;AAzBN;AA2BM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AAzBR;AA6BQ;EACE,sBAAA;AA3BV;AAiCE;EACE,oBAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,gCCrSG;EDsSH,iCAAA;EACA,mBAAA;EACA,sBAAA;AA/BJ;AAiCI;EACE,mBAAA;EACA,iCAAA;EACA,WAAA;EACA,oBAAA;AA/BN;AAmCE;EACE,qBAAA;EACA,sBAAA;AAjCJ;AAoCE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;AAlCJ;AAoCI;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;AAlCN;AAsCE;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;AApCJ;AAuCE;EACE,kBAAA;AArCJ;AAuCI;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AArCN;AAwCI;EACE,kBAAA;AAtCN;AAyCI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AAvCN;AAyCM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAvCR;AAyCQ;EACE,mBAAA;AAvCV;AAyCU;EACE,UAAA;EACA,WAAA;AAvCZ;AAyCY;EACE,eAAA;AAvCd;AA4CQ;EACE,UAAA;EACA,WAAA;AA1CV;AA4CU;EACE,eAAA;EACA,yBAAA;AA1CZ;AAgDI;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;AA9CN;AAgDM;EACE,qBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AA9CR;AAiDM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;AA/CR;AAmDQ;EACE,sBAAA;AAjDV;AAoDQ;EACE,UAAA;EACA,mBAAA;AAlDV;AAuDI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AArDN;AAuDM;EACE,WAAA;EACA,YAAA;EACA,eAAA;AArDR;AAuDQ;EACE,UAAA;EACA,yBAAA;AArDV;AA2DU;EACE,yBCncF;AD0YV;AA8DM;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AA5DR;AAgEI;EACE,kBAAA;AA9DN;AAgEM;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gCCpeD;EDqeC,mBAAA;EACA,YAAA;EACA,aAAA;AA9DR;AAgEQ;EACE,cAAA;EACA,gBAAA;EACA,wCAAA;AA9DV;AAmEI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAjEN;AAoEI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,+BC/fI;EDggBJ,yBAAA;EACA,eAAA;AAlEN;AAoEM;EACE,mCCngBK;ADicb;AAqEU;EACE,yBCxgBF;ADqcV;AAwEM;EACE,sBAAA;AAtER;AAyEM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAvER;AAyEQ;EACE,aAAA;EACA,yBAAA;AAvEV","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n.chat {\r\n  $self: &;\r\n  position: relative;\r\n  font-size: 14px;\r\n  line-height: 100%;\r\n  text-align: left;\r\n  padding: 20px;\r\n  background: $accent;\r\n  color: #fff;\r\n  border-radius: 12px;\r\n\r\n  @media (max-width: 767px) {\r\n    padding: 14px;\r\n  }\r\n\r\n  &--dragging {\r\n    border-color: #fff;\r\n    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);\r\n  }\r\n\r\n  &__drop-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba($accent, 0.92);\r\n    border: 2px dashed #fff;\r\n    border-radius: 12px;\r\n    z-index: 100;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    pointer-events: none;\r\n\r\n    &-content {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      gap: 12px;\r\n      color: #fff;\r\n      font-weight: 600;\r\n      font-size: 16px;\r\n\r\n      svg {\r\n        width: 40px;\r\n        height: 40px;\r\n\r\n        path {\r\n          fill: #fff;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &__message-item {\r\n    position: relative;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-bottom: 12px;\r\n    align-items: start;\r\n  }\r\n\r\n  &__message-time {\r\n    position: relative;\r\n    width: 100%;\r\n    font-size: 11px;\r\n    color: #8b8b8b;\r\n    text-align: left;\r\n    margin-top: 4px;\r\n\r\n    &--from {\r\n      text-align: right;\r\n    }\r\n  }\r\n\r\n  &__message-log {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 12px;\r\n    background: transparent;\r\n    border: 1px solid $main;\r\n    border-radius: 12px;\r\n    width: 100%;\r\n    margin-bottom: 12px;\r\n    gap: 10px;\r\n\r\n    &-title {\r\n      font-weight: 500;\r\n      font-size: 12px;\r\n      line-height: 120%;\r\n      color: #fff;\r\n      opacity: 0.6;\r\n    }\r\n\r\n    &-item {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: flex-end;\r\n      gap: 6px;\r\n      width: 100%;\r\n\r\n      @media (max-width: 480px) {\r\n        flex-wrap: wrap;\r\n        justify-content: flex-start;\r\n      }\r\n    }\r\n\r\n    &-name {\r\n      font-weight: 500;\r\n      font-size: 12px;\r\n      line-height: 120%;\r\n      color: #fff;\r\n      margin-right: auto;\r\n    }\r\n\r\n    &-arrow {\r\n      color: #fff;\r\n      opacity: 0.5;\r\n      font-size: 12px;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n\r\n  &__info {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 10px;\r\n  }\r\n\r\n  &__status {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 6px;\r\n    background: $main;\r\n    color: #fff;\r\n    border-radius: 12px;\r\n    line-height: 100%;\r\n\r\n    span {\r\n      font-weight: 500;\r\n      font-size: 12px;\r\n      line-height: 20px;\r\n      text-align: right;\r\n      color: #fff;\r\n    }\r\n  }\r\n\r\n  &__paid {\r\n    position: relative;\r\n    padding: 9px 16px;\r\n    background: #d6e4ff;\r\n    border-radius: 12px;\r\n    box-shadow: 4px 8px 24px rgba(116, 131, 244, 0.1);\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    font-size: 12px;\r\n    line-height: 1.6;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    color: #4b79ff;\r\n  }\r\n\r\n  &__content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    padding: 0px 10px 0px 0px;\r\n    margin: 20px 0;\r\n    height: 580px;\r\n    overflow-x: auto;\r\n\r\n    @media (max-width: 992px) {\r\n      height: 480px;\r\n    }\r\n\r\n    @media (max-width: 767px) {\r\n      height: 380px;\r\n    }\r\n\r\n    &::-webkit-scrollbar {\r\n      width: 6px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n      background: #fff;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n      background: $main;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb:hover {\r\n      background: $main;\r\n    }\r\n  }\r\n\r\n  &__message-status {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    padding: 10px 12px;\r\n    background: transparent;\r\n    border: 1px solid $main;\r\n    border-radius: 12px;\r\n    margin-bottom: 12px;\r\n    gap: 8px;\r\n\r\n    span {\r\n      font-weight: 500;\r\n      font-size: 12px;\r\n      line-height: 120%;\r\n      color: #fff;\r\n    }\r\n  }\r\n\r\n  &__message-status-main {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n    width: 100%;\r\n\r\n    @media (max-width: 480px) {\r\n      flex-wrap: wrap;\r\n    }\r\n  }\r\n\r\n  &__message-images-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    width: 100%;\r\n\r\n    &--from {\r\n      align-items: flex-end;\r\n    }\r\n  }\r\n\r\n  &__message-images {\r\n    position: relative;\r\n    display: flex;\r\n    gap: 10px;\r\n    z-index: 1;\r\n    margin-bottom: 8px;\r\n\r\n    &--from {\r\n      align-self: flex-end;\r\n    }\r\n\r\n    &-img {\r\n      position: relative;\r\n      left: 0;\r\n      top: 0;\r\n      width: 80px;\r\n      height: 80px;\r\n      z-index: 1;\r\n      border-radius: 12px;\r\n      overflow: hidden;\r\n\r\n      img {\r\n        position: relative;\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n        transition: all 0.3s ease;\r\n      }\r\n\r\n      &:hover {\r\n        img {\r\n          transform: scale(1.05);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &__message {\r\n    display: inline-flex;\r\n    align-items: flex-end;\r\n    gap: 8px;\r\n    max-width: 85%;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 1.4;\r\n    text-align: left;\r\n    padding: 12px;\r\n    color: #fff;\r\n    background: $main;\r\n    border-radius: 2px 16px 16px 16px;\r\n    margin-bottom: 12px;\r\n    word-break: break-word;\r\n\r\n    &--from {\r\n      background: #374151;\r\n      border-radius: 16px 16px 2px 16px;\r\n      color: #fff;\r\n      align-self: flex-end;\r\n    }\r\n  }\r\n\r\n  &__message-text {\r\n    white-space: pre-wrap;\r\n    word-break: break-word;\r\n  }\r\n\r\n  &__message-meta {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: 2px;\r\n\r\n    &--outside {\r\n      padding-right: 2px;\r\n      margin-top: -4px;\r\n      margin-bottom: 8px;\r\n    }\r\n  }\r\n\r\n  &__message-time-inline {\r\n    flex-shrink: 0;\r\n    align-self: flex-end;\r\n    font-size: 11px;\r\n    line-height: 1;\r\n    color: rgba(255, 255, 255, 0.65);\r\n    margin-left: 4px;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  &__form {\r\n    position: relative;\r\n\r\n    &-images {\r\n      position: relative;\r\n      display: flex;\r\n      gap: 10px;\r\n      z-index: 1;\r\n      margin-bottom: 20px;\r\n    }\r\n\r\n    &-wrapper {\r\n      position: relative;\r\n    }\r\n\r\n    &-controls {\r\n      position: absolute;\r\n      top: 3px;\r\n      right: 3px;\r\n      z-index: 2;\r\n      opacity: 0;\r\n      visibility: hidden;\r\n      transition: all 0.3s ease;\r\n\r\n      a {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        width: 24px;\r\n        height: 24px;\r\n        background: #ffd0d0;\r\n        border-radius: 9px;\r\n        cursor: pointer;\r\n        transition: all 0.3s ease;\r\n\r\n        &:hover {\r\n          background: #FF2B2B;\r\n\r\n          svg {\r\n            width: 8px;\r\n            height: 8px;\r\n\r\n            path {\r\n              stroke: #ffd0d0;\r\n            }\r\n          }\r\n        }\r\n\r\n        svg {\r\n          width: 8px;\r\n          height: 8px;\r\n\r\n          path {\r\n            stroke: #FF2B2B;\r\n            transition: all 0.3s ease;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    &-img {\r\n      position: relative;\r\n      left: 0;\r\n      top: 0;\r\n      width: 80px;\r\n      height: 80px;\r\n      z-index: 1;\r\n      border-radius: 12px;\r\n      overflow: hidden;\r\n\r\n      a {\r\n        text-decoration: none;\r\n        display: block;\r\n        width: 100%;\r\n        height: 100%;\r\n      }\r\n\r\n      img {\r\n        position: relative;\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n        transition: all 0.3s ease;\r\n      }\r\n\r\n      &:hover {\r\n        img {\r\n          transform: scale(1.05);\r\n        }\r\n\r\n        #{$self}__form-controls {\r\n          opacity: 1;\r\n          visibility: visible;\r\n        }\r\n      }\r\n    }\r\n\r\n    &-attach {\r\n      position: absolute;\r\n      left: 15px;\r\n      top: 13px;\r\n      z-index: 1;\r\n      cursor: pointer;\r\n\r\n      svg {\r\n        width: 16px;\r\n        height: 16px;\r\n        cursor: pointer;\r\n\r\n        path {\r\n          fill: #fff;\r\n          transition: all 0.3s ease;\r\n        }\r\n      }\r\n\r\n      &:hover {\r\n        svg {\r\n          path {\r\n            fill: $accent;\r\n          }\r\n        }\r\n      }\r\n\r\n      input {\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n        opacity: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        z-index: 1;\r\n        cursor: pointer;\r\n      }\r\n    }\r\n\r\n    &-textarea {\r\n      position: relative;\r\n\r\n      input {\r\n        position: relative;\r\n        display: block;\r\n        width: 100%;\r\n        font-style: normal;\r\n        font-weight: 500;\r\n        font-size: 14px;\r\n        line-height: 1.6;\r\n        letter-spacing: 0.2px;\r\n        text-align: left;\r\n        color: #fff;\r\n        padding: 10px 43px;\r\n        background: $main;\r\n        border-radius: 12px;\r\n        border: none;\r\n        outline: none;\r\n\r\n        &::placeholder {\r\n          color: #9e9e9e;\r\n          font-weight: 500;\r\n          font-family: \"IBM Plex Sans\", sans-serif;\r\n        }\r\n      }\r\n    }\r\n\r\n    &-button {\r\n      position: absolute;\r\n      right: 5px;\r\n      top: 5px;\r\n    }\r\n\r\n    &-btn {\r\n      position: relative;\r\n      width: 33px;\r\n      height: 33px;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      border: none;\r\n      border-radius: 10px;\r\n      background: $accent;\r\n      transition: all 0.3s ease;\r\n      cursor: pointer;\r\n\r\n      &:hover {\r\n        background: $additional;\r\n\r\n        svg {\r\n          path {\r\n            fill: $accent;\r\n          }\r\n        }\r\n      }\r\n\r\n      &:active {\r\n        transform: scale(0.95);\r\n      }\r\n\r\n      svg {\r\n        position: relative;\r\n        right: -1px;\r\n        width: 15px;\r\n        height: 15px;\r\n\r\n        path {\r\n          fill: #FFFFFF;\r\n          transition: all 0.3s ease;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);\r\n$primary: #131313;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
